import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { EMOJIS } from "../lib/api";

const SECONDS = 10;

export const ThankYou = ({ rating, onAgain }) => {
  const [left, setLeft] = useState(SECONDS);
  useEffect(() => {
    const t = setInterval(() => setLeft((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    if (left <= 0) onAgain();
  }, [left, onAgain]);

  return (
  <motion.div
    data-testid="thank-you-message-container"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-[rgba(18,15,12,0.96)] backdrop-blur-md px-8 text-center"
  >
    <motion.div
      initial={{ scale: 0, rotate: -30 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 200, damping: 12 }}
      className="text-7xl mb-6"
    >
      {EMOJIS[(rating || 1) - 1].e}
    </motion.div>
    <h2 className="font-display text-4xl sm:text-5xl font-light">
      Bedankt, <em className="italic text-[var(--amber)]">genoteerd.</em>
    </h2>
    <p className="mt-3 text-sm text-[var(--muted)]">Je {rating}/10 is nu onderdeel van het verhaal van deze plek.</p>
    <motion.button
      data-testid="review-again-btn"
      onClick={onAgain}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.95 }}
      className="mt-8 rounded-full border border-[var(--paper)]/40 px-6 py-2.5 text-sm hover:bg-[var(--paper)] hover:text-[var(--ink)] transition-colors"
    >
      Nu terug naar het begin
    </motion.button>
    <p data-testid="auto-reset-countdown" className="mt-4 font-mono-clock text-xs text-[var(--muted)]">
      Over {Math.max(left, 0)}s terug naar het begin
    </p>
    <div className="mt-3 h-[2px] w-40 bg-[rgba(244,237,225,0.15)] overflow-hidden rounded-full">
      <motion.div className="h-full bg-[var(--amber)]" initial={{ width: "100%" }} animate={{ width: 0 }} transition={{ duration: SECONDS, ease: "linear" }} />
    </div>
  </motion.div>
  );
};
